module.exports = __webpack_public_path__ + "img/vp-logo-dark.dbb0e1a0.svg";